import React from 'react';

import { SERVICE_PROVIDER_CATEGORY_GROUPS } from '../../config/serviceProviderCategories';

/**
 * Grouped <option> list for service category selects.
 * @param {{ includeEmpty?: boolean, emptyLabel?: string }} [props]
 */
const ServiceCategoryOptions = ({ includeEmpty = false, emptyLabel = 'Choose…' }) => (
  <>
    {includeEmpty ? <option value="">{emptyLabel}</option> : null}
    {SERVICE_PROVIDER_CATEGORY_GROUPS.map(group => (
      <optgroup key={group.id} label={group.label}>
        {group.categories.map(c => (
          <option key={c.id} value={c.id}>
            {c.label}
          </option>
        ))}
      </optgroup>
    ))}
  </>
);

export default ServiceCategoryOptions;
